import GetArcGISToken from "./GetArcGISToken";
export default function(url) {
  let token = "&t=" + GetArcGISToken.user?.ceddToken;
  if (typeof url === "string") return url + token;
  else if (Array.isArray(url)) {
    return (
      "/WebAPI/ViewFile.aspx?" +
      url.map((i, j) => `f${j + 1}=${i}`).join("&") +
      token
    );
  }
}
